// extracted by mini-css-extract-plugin
export var loadingSpinner = "_5o-1";
export var standaloneTable = "_5o-0";